<template>
  <div class="init-notice">
    <div
      :style="{ height: language == 'en_US' ? '6rem' : '5.6rem' }"
      class="init-notice-content"
    >
      <div class="left-navigation">
        <div class="navigation-title">
          {{ `${$t("notice.caseDetail.gxnr")}` }}
        </div>
        <div
          v-if="hasEditViewControl"
          :class="
            ![2, 3].includes(activeKey)
              ? 'navigation-item-active'
              : 'navigation-item'
          "
          @click="activeKey = 0"
        >
          <!--          {{ `${$t("notice.caseDetail.jdtz")}` }}-->
          病例咨询
        </div>
        <div
          v-if="hasEditViewControl"
          :class="
            [2, 3].includes(activeKey)
              ? 'navigation-item-active'
              : 'navigation-item'
          "
          @click="activeKey = 2"
        >
          {{ `${$t("notice.caseDetail.jdtz")}` }}
        </div>
      </div>
      <div class="right-content">
        <div class="close-notice" @click="noPrompt"></div>
        <div
          v-for="(item, index) in contentWraps"
          v-if="item.canShow"
          :key="index"
          :style="{ display: activeKey === index ? 'flex' : 'none' }"
          class="content-item"
        >
          <div :class="`img${index + 1}`"></div>
          <div class="message-content">
            <div class="title">
              {{ item.title }}
              <div v-if="hasEditViewControl" class="step-wrap">
                {{ `${index + 1} / ${contentWraps.length}` }}
              </div>
            </div>
            <div v-if="index === 3">
              <div class="message-item">
                {{ `${$t("notice.caseDetail.kck")}` }}

                <span class="link" @click="toHelp">
                  {{ `${$t("notice.caseDetail.help")}` }}
                  <i class="el-icon-arrow-right"></i
                ></span>
              </div>
            </div>
            <div
              v-for="(cItem, cIndex) in item.message"
              :key="cIndex"
              class="message-item"
            >
              {{ cItem }}
            </div>
            <div class="step-controls">
              <div
                v-if="hasEditViewControl"
                :class="activeKey === 0 ? 'prev-step-disabled' : 'prev-step'"
                @click="prevStep"
              >
                {{ `${$t("notice.threeD.syg")}` }}
              </div>
              <div v-else></div>
              <div class="next-step " @click="nextStep">
                {{
                  activeKey === 3
                    ? `${$t("notice.caseDetail.zd")}`
                    : `${$t("notice.threeD.xyg")}`
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { changeLocalStorageNoticeData } from "@/common/js/util.js";
import { mapState } from "vuex";

export default {
  props: {
    hasEditViewControl: Boolean,
    noticeKey: Object
  },
  data() {
    return {
      activeKey: this.hasEditViewControl ? 0 : 3,
      navigators: [this.$t("notice.caseDetail.jdtz")],

      contentWraps: [
        {
          // img: "--view3d-init-notice-bg1",
          title: this.$t("notice.caseDetail.blzx"),
          message: [
            this.$t("notice.caseDetail.xzblzx"),
            this.$t("notice.caseDetail.blzxnr")
          ],
          canShow: this.hasEditViewControl
        },
        {
          // img: "--view3d-init-notice-bg1",
          title: this.$t("notice.caseDetail.blzx"),
          message: [this.$t("notice.caseDetail.blzxzr")],
          canShow: this.hasEditViewControl
        },
        {
          // img: "--view3d-init-notice-bg1",
          title: this.$t("notice.caseDetail.jdtz"),
          message: [
            this.$t("notice.caseDetail.xzjdtz"),
            this.$t("notice.caseDetail.jdtznr")
          ],
          canShow: this.hasEditViewControl
        },
        {
          img: "--view3d-init-notice-bg3",
          title: this.$t("notice.caseDetail.jdtz"),
          canShow: true
        }
      ]
    };
  },
  computed: {
    ...mapState({
      language: state => state.language
    })
  },
  methods: {
    toHelp() {
      window.open("/helpCenter?type=22");
    },
    noPrompt() {
      changeLocalStorageNoticeData(this.noticeKey, false);
      this.$emit("closeDrawer");
    },
    nextStep() {
      console.log("activeKey", this.activeKey);
      if (this.activeKey === 3) {
        this.noPrompt();
      } else {
        this.activeKey += 1;
      }
    },
    prevStep() {
      if (this.activeKey === 0) return;
      this.activeKey -= 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.init-notice {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(51, 51, 51, 0.4);
  z-index: 999;

  &-content {
    width: 852px;
    height: 560px;
    border-radius: 8px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    background-color: #fff;
    display: flex;

    .left-navigation {
      display: flex;
      flex-direction: column;
      width: 192px;
      padding: 16px 0;
      background-color: var(--view3d-init-notice-left-bgcolor);

      .navigation-title {
        padding-left: 20px;
        font-size: 20px;
        line-height: 28px;
        font-weight: bold;
        margin-bottom: 16px;
        //color: #FCC80E;
        color: var(--textColor);
      }

      .navigation-item,
      .navigation-item-active {
        color: $main_theme_color;
        //color: var(--textColor);
        cursor: pointer;
        position: relative;
        padding-left: 32px;
        height: 48px;
        display: flex;
        align-items: center;
        font-size: 16px;
      }

      .navigation-item-active {
        background: #f9f9f9;
        //background: var(--view3d-init-notice-left-active-item);
        //color: var(--mainColor);
        color:$main_theme_color;

        &::before {
          content: "";
          position: absolute;
          width: 2px;
          height: 24px;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          background-color:$main_theme_color;
          //background-color: var(--mainColor);
        }
      }
    }

    .right-content {
      flex: 1;
      display: flex;
      flex-direction: column;

      .content-item {
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .close-notice {
        cursor: pointer;
        width: 16px;
        height: 16px;
        position: absolute;
        z-index: 1;
        right: 20px;
        top: 20px;
        background: url(./img/close.png) no-repeat center;
        background-size: 100% 100%;
      }

      .img1,
      .img2,
      .img3,
      .img4,
      .img5 {
        width: 660px;
        height: 370px;
      }

      .img1 {
        background: url(img/bg1.png) no-repeat center;
        background-size: 100% 100%;
      }

      .img2 {
        background: url(img/bg2.png) no-repeat center;
        background-size: 100% 100%;
      }

      .img3 {
        background: url(img/bg3.png) no-repeat center;
        background-size: 100% 100%;
      }

      .img4 {
        background: url(img/bg4.png) no-repeat center;
        background-size: 100% 100%;
      }

      .img5 {
        background: var(--view3d-init-notice-bg3) no-repeat center;
        background-size: 100% 100%;
      }

      .message-content {
        position: relative;
        box-sizing: border-box;
        flex: 1;
        border-left: 1px solid
          var(--view3d-init-notice-message-content-border-color);
      }

      .title {
        font-size: 18px;
        color: var(--textColor);
        line-height: 26px;
        margin: 16px 0 8px;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .step-wrap {
          width: 48px;
          height: 24px;
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.16);
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .message-item {
        padding: 0 16px;
        font-size: 14px;
        line-height: 28px;
        color: var(--textColor);

        .link {
          cursor: pointer;
          color: $main_theme_color;
          //color: var(--mainColor);
        }
      }

      .step-controls {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 16px;
        left: 16px;
        right: 16px;

        .next-step,
        .prev-step,
        .prev-step-disabled {
          user-select: none;
          cursor: pointer;
          height: 36px;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          color: $main_theme_color;
          //color: var(--mainColor);
        }

        .prev-step-disabled {
          cursor: not-allowed;
          color: #999999;
        }

        .next-step {
          min-width: 96px;
          padding: 0 20px;
          color: #333333;
          background-color: $main_theme_color;
          //background-color: var(--mainColor);
        }
      }
    }
  }
}
</style>
